"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _UISelect = _interopRequireDefault(require("../input/UISelect"));

var _UISearchInput = _interopRequireDefault(require("../input/UISearchInput"));

var _UIDropdownDivider = _interopRequireDefault(require("../dropdown/UIDropdownDivider"));

var _underscore = require("../utils/underscore");

var ToolbarSelectSearchInput = function ToolbarSelectSearchInput(props) {
  return _react.default.createElement(_UISearchInput.default, (0, _extends2.default)({}, props, {
    clearable: false,
    icon: false,
    inputClassName: "private-form__control--small"
  }));
};

var hasGroups = function hasGroups(options) {
  return options[0] && options[0].options;
};

var flattenOptions = function flattenOptions(options) {
  if (!hasGroups(options)) return options;
  var flatOptions = [];
  options.forEach(function (optionGroup, i) {
    optionGroup.options.forEach(function (option) {
      return flatOptions.push(option);
    });
    if (i < options.length - 1) flatOptions.push({
      disabled: true,
      isSpecial: true,
      text: '',
      value: '',
      rawNode: _react.default.createElement(_UIDropdownDivider.default, {
        className: "m-all-0"
      })
    });
  });
  return flatOptions;
};

var UITextToolbarSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UITextToolbarSelect, _PureComponent);

  function UITextToolbarSelect(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UITextToolbarSelect);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITextToolbarSelect).call(this, props));
    _this.state = {
      buttonStyle: null
    };
    _this._id = (0, _underscore.uniqueId)('text-toolbar-select-');
    _this._flattenOptions = (0, _memoizeOne.default)(flattenOptions);
    _this.computeButtonStyle = _this.computeButtonStyle.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UITextToolbarSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.computeButtonStyle();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevProps.options !== this.props.options) {
        this.computeButtonStyle();
      }
    }
  }, {
    key: "computeButtonStyle",
    value: function computeButtonStyle() {
      // Set the button width based on the widest option text.
      var _this$props = this.props,
          options = _this$props.options,
          placeholder = _this$props.placeholder;
      var buttonStyle = this.state.buttonStyle;
      var buttonEl = document.getElementById(this._id);
      if (!buttonEl) return;
      var originalButtonElWidthStyle = buttonEl.style.width;
      buttonEl.style.width = '';
      var textEl = buttonEl.querySelector('[data-option-text]');
      var originalTextElContents = textEl.innerHTML;
      var maxButtonWidth = 0;

      if (placeholder) {
        textEl.textContent = placeholder;
        maxButtonWidth = buttonEl.offsetWidth;
      }

      var flatOptions = this._flattenOptions(options);

      flatOptions.forEach(function (option) {
        textEl.textContent = option.text;
        var measuredOptionWidth = buttonEl.offsetWidth;
        maxButtonWidth = Math.max(maxButtonWidth, measuredOptionWidth);
      });
      maxButtonWidth = Math.ceil(maxButtonWidth + 1);

      if (maxButtonWidth === 0) {
        this.setState({
          buttonStyle: null
        });
      } else if (!buttonStyle || buttonStyle.width !== maxButtonWidth) {
        this.setState({
          buttonStyle: {
            width: maxButtonWidth
          }
        });
      }

      buttonEl.style.width = originalButtonElWidthStyle;
      textEl.innerHTML = originalTextElContents;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          options = _this$props2.options,
          showSearchbox = _this$props2.showSearchbox,
          use = _this$props2.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "options", "showSearchbox", "use"]);
      var buttonStyle = this.state.buttonStyle;

      var flatOptions = this._flattenOptions(options);

      return _react.default.createElement(_UISelect.default, (0, _extends2.default)({
        buttonSize: "small",
        buttonStyle: buttonStyle,
        buttonUse: use === 'on-dark' ? 'tertiary-extra-light' : 'tertiary-light',
        className: (0, _classNames.default)('private-button--toolbar', className),
        id: this._id,
        minimumSearchCount: showSearchbox ? 0 : Infinity,
        options: flatOptions,
        resultsClassName: "private-typeahead-results--toolbar",
        searchClassName: "private-search-control__wrapper--toolbar",
        SearchInput: ToolbarSelectSearchInput
      }, rest));
    }
  }]);
  return UITextToolbarSelect;
}(_react.PureComponent);

UITextToolbarSelect.propTypes = {
  defaultValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  options: _UISelect.default.propTypes.options.isRequired,
  placeholder: _react.PropTypes.string,
  showSearchbox: _react.PropTypes.bool.isRequired,
  use: _react.PropTypes.oneOf(['', 'on-dark']).isRequired,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
};
UITextToolbarSelect.defaultProps = {
  showSearchbox: false,
  use: ''
};
UITextToolbarSelect.displayName = 'UITextToolbarSelect';
var _default = UITextToolbarSelect;
exports.default = _default;
module.exports = exports.default;